// services/adminService.js
import api from './api';

// Create a new Business Account
export const createBusiness = async (businessData) => {
  const { data } = await api.post('/admin/business', businessData);
  return data.data;
};

// Update an existing Business Account
export const updateBusiness = async (businessId, businessData) => {
  const { data } = await api.put(`/admin/businesses/${businessId}`, businessData);
  return data.data;
};

// Get all Businesses
export const getAllBusinesses = async () => {
  const { data } = await api.get('/admin/businesses');
  return data.data;
};

// Delete a Business Account
export const deleteBusiness = async (businessId) => {
  const { data } = await api.delete(`/admin/businesses/${businessId}`);
  return data.data;
};
